import { useBaseApplicationTranslation as s } from "../../../../shared/libraries/local-translations/index.js";
import { getAffiliateName as r } from "../../../../base_application/ui/utilities/index2.js";
class m {
  constructor(e) {
    this.options = e;
  }
  translateName(e) {
    let t = e.name, a = e.name;
    if (e.code === "MISC") {
      const { t: o } = s();
      t = o("header.All"), a = o("header.all-documents", {
        siteBrand: r() ?? this.options.siteBrand
      });
    }
    return {
      desktopName: t,
      mobileName: a
    };
  }
}
export {
  m as DefaultMenuCategoryNameTranslator
};
//# sourceMappingURL=index2.js.map
